import React, { FC } from "react";
import { defaultStub } from "@evergis/ui";

import { FallbackImage, ImageFallbackContainer } from "./styled";

export const ImageFallback: FC<{ src: string; fallback?: string; color?: string; selected?: boolean }> = ({
  src,
  fallback = defaultStub,
  color,
  selected,
}) => (
  <ImageFallbackContainer color={color} fallback={fallback} selected={selected}>
    <FallbackImage src={src} />
  </ImageFallbackContainer>
);
